import { ReactNode } from 'react';

export function Page({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col items-stretch overflow-hidden h-full">
      {children}
    </div>
  );
}
